export type GuestType = 'LOCAL' | 'FOREIGNER';

import { Location } from "../Models";

export interface MapKeyValue {
    key: "filter_by_price_range" | "filter_by_township" | "sort_by_price"
    value: string
}

export default class HotelSearchCriteria {
    private location: Location;
    private checkInDate: string;
    private checkOutDate: string;
    private numberOfRooms: number;
    private guestType: GuestType;
    private offset: number;
    private size: number;
    
    //private filterSorter: HotelFilterAndSortCriteria | null;
    private filterByTownship: string | null;
    private filterByPriceRange: string | null;
    private sortByPrice: string | null;

    constructor(location:Location, checkInDate:string, checkOutDate:string, numberOfRooms:number, guestType:GuestType, 
        filterByTownship: string | null = null,
        filterByPriceRange: string | null = null,
        sortByPrice: string | null = null, offset: number = 1) {

        this.location = location;
        this.checkInDate = checkInDate;
        this.checkOutDate = checkOutDate;
        this.numberOfRooms = numberOfRooms;
        this.guestType = guestType;
        this.offset = offset;
        this.size = 10;
        this.filterByTownship = filterByTownship;
        this.filterByPriceRange = filterByPriceRange;
        this.sortByPrice = sortByPrice;
    }

    getLocation():Location {
        return this.location;
    }

    getCheckInDate():string {
        return this.checkInDate;
    }

    getCheckOutDate():string {
        return this.checkOutDate;
    }

    getGuestType():GuestType {
        return this.guestType;
    }

    getNumberOfRooms(): number {
        return this.numberOfRooms;
    }

    getOffset(): number {
        return this.offset;
    }

    getSize(): number {
        return this.size;
    }

    getFilterByTownship() : string|null {
        return this.filterByTownship;
    }

    getFilterByPriceRange() : string|null {
        return this.filterByPriceRange;
    }

    getSortByPrice() : string|null {
        return this.sortByPrice;
    }

    withFilterByTownship(value:string) : HotelSearchCriteria {
        return new HotelSearchCriteria(
            this.location, this.checkInDate, this.checkOutDate, 
            this.numberOfRooms, this.guestType, 
            value, this.filterByPriceRange, this.sortByPrice, this.offset); 
    }

    withoutFilterByTownship() : HotelSearchCriteria {
        return new HotelSearchCriteria(
            this.location, this.checkInDate, this.checkOutDate, 
            this.numberOfRooms, this.guestType, 
            null, this.filterByPriceRange, this.sortByPrice, this.offset); 
    }

    withFilterByPriceRange(value:string) : HotelSearchCriteria {
        return new HotelSearchCriteria(
            this.location, this.checkInDate, this.checkOutDate, 
            this.numberOfRooms, this.guestType, 
            this.filterByTownship, value, this.sortByPrice, this.offset); 
    }

    withoutFilterByPriceRange() : HotelSearchCriteria {
        return new HotelSearchCriteria(
            this.location, this.checkInDate, this.checkOutDate, 
            this.numberOfRooms, this.guestType, 
            this.filterByTownship, null, this.sortByPrice, this.offset); 
    }

    withSortByPrice(value:string) : HotelSearchCriteria {
        return new HotelSearchCriteria(
            this.location, this.checkInDate, this.checkOutDate, 
            this.numberOfRooms, this.guestType, 
            this.filterByTownship, this.filterByPriceRange, value, this.offset); 
    }

    withoutSortByPrice() : HotelSearchCriteria {
        return new HotelSearchCriteria(
            this.location, this.checkInDate, this.checkOutDate, 
            this.numberOfRooms, this.guestType, 
            this.filterByTownship, this.filterByPriceRange, null, this.offset); 
    }

    withOffset(value: number) {
        return new HotelSearchCriteria(
            this.location, this.checkInDate, this.checkOutDate, 
            this.numberOfRooms, this.guestType, 
            this.filterByTownship, this.filterByPriceRange, this.sortByPrice, value); 
    }
}